import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { hideSignInModal } from 'data/account/actions/signInModal';
import EmailVerification from '../components/EmailVerification';
import FirstSignIn from '../components/FirstSignIn';
import SignIn from '../components/SignIn';
import SignUpContainer from './SignUpContainer';
import ForgotPassword from '../components/ForgotPassword';
import EmailSent from '../components/EmailSent';
import Modal from '../components/Modal';

const SignInModalContainer = ({open}) => {
  const dispatch = useDispatch();
  const showEmailVerification = useSelector(state => state.account.signInModal.showEmailVerification); //state
  const showFirstSignIn = useSelector(state => state.account.signInModal.showFirstSignIn); //state
  const showSignIn = useSelector(state => state.account.signInModal.showSignIn);
  const showSignUp = useSelector(state => state.account.signInModal.showSignUp);
  const showForgotPassword = useSelector(state => state.account.signInModal.showForgotPassword);
  const showEmailSent = useSelector(state => state.account.signInModal.showEmailSent);
  const showSuccess = useSelector(state => state.account.signUp.submitted && state.account.signUp.success);

  const handleRequestClose = () => {
    if (showSuccess) {
      return;
    }
    dispatch(hideSignInModal());
  };

  return (<>
    <Modal open={open} onRequestClose={handleRequestClose}>
        {showSignUp ? <SignUpContainer /> : <div className='py-5 px-10 overflow-y-auto max-h-screen'>
            <div className="w-full flex justify-center my-6">
                <img className='w-1/3 max-w-[300px]' src={`/assets/img/logo/logo2020-500.png`} />
            </div>
            {showEmailVerification && <EmailVerification />}
            {showFirstSignIn && <FirstSignIn />}
            {showSignIn && <SignIn />}
            {showForgotPassword && <ForgotPassword />}
            {showEmailSent && <EmailSent />}
        </div>}
    </Modal>
  </>);
};

SignInModalContainer.propTypes = {
    hideSignInModal: PropTypes.func,
    showEmailVerification: PropTypes.bool,
    showFirstSignIn: PropTypes.bool,
    showSignIn: PropTypes.bool,
    showSignUp: PropTypes.bool,
    showForgotPassword: PropTypes.bool,
    showSuccess: PropTypes.bool,
    className: PropTypes.string,
    overlayClassName: PropTypes.string
};

export default SignInModalContainer;